// src/firebase.js
// ─────────────────────────────────────────────
// STEP 1: Go to https://console.firebase.google.com
// STEP 2: Create a new project → "apnasatna"
// STEP 3: Add a Web App → copy your firebaseConfig below
// STEP 4: Enable Authentication → Email/Password + Google
// STEP 5: Enable Firestore Database (production mode)
// STEP 6: Enable Storage (for property images)
// ─────────────────────────────────────────────

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// 🔴 REPLACE with your actual Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyAODnj6A8ZbYloYR1uu-9uu8HfliCApgis",
  authDomain: "apnasatna-edd85.firebaseapp.com",
  projectId: "apnasatna-edd85",
  storageBucket: "apnasatna-edd85.firebasestorage.app",
  messagingSenderId: "176277831044",
  appId: "1:176277831044:web:c557aeb9bf16857018f1d1"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Auth
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('profile');
googleProvider.addScope('email');
googleProvider.setCustomParameters({ prompt: 'select_account' });

// Firestore DB
export const db = getFirestore(app);

// Storage (for images)
export const storage = getStorage(app);

export default app;
